import { type User } from "interfaces";
import { FilterType, type FilterTypesMap } from "utils/filterUtils";

export enum ExternalLinksFiltersEnum {
  Tags = "tags",
  SoftwareApplications = "softwareApplications",
  Labels = "labels",
  Packs = "packIds",
  Publishers = "publisherIds",
  DateCreated = "dateCreated",
  DateModified = "dateModified",
  Visibility = "visibility",
}

export const externalLinksFilterTypes: FilterTypesMap<ExternalLinksFiltersEnum> = {
  dateCreated: FilterType.DateRange,
  dateModified: FilterType.DateRange,
  labels: FilterType.Array,
  packIds: FilterType.Array,
  publisherIds: FilterType.Array,
  softwareApplications: FilterType.Array,
  tags: FilterType.Array,
  visibility: FilterType.Value,
};

export interface LinkUser extends User {
  editable: boolean;
  inherited: boolean;
}
